import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/ImageWithTextOverlay/ImageWithTextOverlay.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.ImageWithTextOverlay';
export {styles};